import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from './supabaseClient';
import './ComingSoon.css';

export default function EmployerAccountChoice() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  async function switchAccount() {
    setBusy(true);
    setError('');
    try {
      const { error: signOutError } = await supabase.auth.signOut({ scope: 'local' });
      if (signOutError) throw signOutError;
      // The existing auth subscription replaces this choice with employer sign-in.
    } catch {
      setError('We could not sign you out. Please try again.');
      setBusy(false);
    }
  }

  return (
    <main className="cs-root cs-account-choice">
      <section className="cs-preview" aria-labelledby="account-choice-title">
        <Link className="cs-logo" to="/">Vet<span>Qualified</span></Link>
        <p className="cs-eyebrow">Employer access</p>
        <h1 id="account-choice-title">You’re signed in as a member</h1>
        <p className="cs-lead">Hiring uses a separate employer account. You can return to your member profile, or sign out of this browser to sign in with an employer account.</p>
        <p className="cs-access">Creating a new employer account requires an employer early-access code. Your member account will not be converted.</p>
        {error && <p className="cs-account-error" role="alert">{error}</p>}
        <div className="cs-actions">
          <button className="cs-btn" type="button" disabled={busy} onClick={switchAccount}>{busy ? 'Signing out…' : 'Sign out and continue as employer'}</button>
          <Link className="cs-btn cs-btn-secondary" to="/dashboard">Return to my member profile</Link>
        </div>
      </section>
    </main>
  );
}
